import React, { useState, useEffect } from 'react';
import BaseApiService from '../services/BaseApiService';

const SecureAccountSettings = ({ orgData, onClose }) => {
  const [accountDetails, setAccountDetails] = useState({
    upiId: ''
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch existing UPI ID on mount
  useEffect(() => {
    const fetchExistingUpi = async () => {
      if (!orgData?.orgId) return;
      try {
        setFetching(true);
        const apiService = new BaseApiService();
        const existingUpiData = await apiService.makeRequest(`/api/fees/admin/config/upi/${orgData?.orgId}`);
        console.log('Existing UPI response:', existingUpiData);
        
        let upiId = null;
        if (existingUpiData.success && existingUpiData.config?.upiId) {
          upiId = existingUpiData.config.upiId;
        } else if (existingUpiData.success && existingUpiData.data?.upiId) {
          upiId = existingUpiData.data.upiId;
        } else if (existingUpiData.upiId) {
          upiId = existingUpiData.upiId;
        }
        
        if (upiId) {
          setAccountDetails({
            upiId: upiId
          });
          console.log('UPI ID loaded:', upiId);
        }
      } catch (fetchError) {
        console.log('No existing UPI ID found or error fetching:', fetchError);
      } finally {
        setFetching(false);
      }
    };
    
    fetchExistingUpi();
  }, [orgData]);

  // Handle account details update
  const handleUpdateAccountDetails = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      // Validate inputs
      if (!accountDetails.upiId) {
        setErrorMessage('Please provide UPI ID');
        setLoading(false);
        return;
      }

      const apiService = new BaseApiService();
      const data = await apiService.makeRequest('/api/fees/admin/config/upi', {
        method: 'POST',
        body: JSON.stringify({
          orgId: orgData?.orgId,
          upiId: accountDetails.upiId,
          merchantName: orgData?.orgName
        })
      });

      if (data.success) {
        setSuccessMessage(data.message || 'Account details updated successfully!');
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setErrorMessage(data.message || 'Failed to update account details. Please try again.');
      }
    } catch (error) {
      setErrorMessage(error.message || 'Failed to update account details. Please try again.');
      console.error('Update error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
          paddingBottom: '20px',
          borderBottom: '2px solid #f0f0f0'
        }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#1f2937' }}>
            ⚙️ Account Settings
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: 0,
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {fetching ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
            Loading account configurations...
          </div>
        ) : (
          <div>
            <form onSubmit={handleUpdateAccountDetails}>
              {/* UPI ID */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontWeight: '600',
                  color: '#1f2937',
                  fontSize: '14px'
                }}>
                  UPI ID *
                </label>
                <input
                  type="text"
                  placeholder="example@upi"
                  value={accountDetails.upiId}
                  onChange={(e) => setAccountDetails({
                    upiId: e.target.value
                  })}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Messages */}
              {successMessage && (
                <div style={{
                  padding: '12px',
                  backgroundColor: '#d1fae5',
                  borderRadius: '6px',
                  borderLeft: '4px solid #10b981',
                  marginBottom: '15px'
                }}>
                  <p style={{ margin: 0, fontSize: '13px', color: '#065f46' }}>
                    ✓ {successMessage}
                  </p>
                </div>
              )}

              {errorMessage && (
                <div style={{
                  padding: '12px',
                  backgroundColor: '#fee2e2',
                  borderRadius: '6px',
                  borderLeft: '4px solid #ef4444',
                  marginBottom: '15px'
                }}>
                  <p style={{ margin: 0, fontSize: '13px', color: '#7f1d1d' }}>
                    ✗ {errorMessage}
                  </p>
                </div>
              )}

              {/* Buttons */}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    flex: 1,
                    padding: '12px',
                    backgroundColor: '#f3f4f6',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#e5e7eb';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#f3f4f6';
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    flex: 1,
                    padding: '12px',
                    backgroundColor: loading ? '#d1d5db' : '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = '#059669';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = '#10b981';
                    }
                  }}
                >
                  {loading ? 'Updating...' : 'Update Details'}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecureAccountSettings;
